import React, { useRef } from 'react';
import { downloadPDF } from '../../services/pdf';
import './PreviewView.css';
import './printStyles.css';

export default function PreviewView({
  templateContent,
  templateType,
  pageSettings = { paperSize: 'letter', marginTop: 1, marginRight: 1, marginBottom: 1, marginLeft: 1 },
}) {
  const previewRef = useRef(null);
  const marginStyle = {
    paddingTop: `${pageSettings.marginTop ?? 1}in`,
    paddingRight: `${pageSettings.marginRight ?? 1}in`,
    paddingBottom: `${pageSettings.marginBottom ?? 1}in`,
    paddingLeft: `${pageSettings.marginLeft ?? 1}in`,
  };

  const handlePrint = () => {
    const marginStyle = {
      paddingTop: `${pageSettings.marginTop ?? 1}in`,
      paddingRight: `${pageSettings.marginRight ?? 1}in`,
      paddingBottom: `${pageSettings.marginBottom ?? 1}in`,
      paddingLeft: `${pageSettings.marginLeft ?? 1}in`,
    };
    const marginCss = `padding: ${marginStyle.paddingTop} ${marginStyle.paddingRight} ${marginStyle.paddingBottom} ${marginStyle.paddingLeft};`;
    const printStyles = `
      * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
      body { margin: 0; font-family: 'Liberation Serif', 'Times New Roman', serif; font-size: 12pt; line-height: 1.6; color: #2d3748; }
      .preview-pdf-content { ${marginCss} }
      .preview-pdf-content p { margin: 0 0 12px 0; }
      .preview-pdf-content figure.table { display: block; width: 100%; margin: 1em 0; }
      .preview-pdf-content figure.table table { display: table !important; width: 100% !important; border-collapse: collapse; margin: 0; table-layout: auto; }
      .preview-pdf-content figure.table td, .preview-pdf-content figure.table th { display: table-cell !important; }
      .preview-pdf-content table { width: 100%; border-collapse: collapse; margin: 20px 0; display: table !important; background-color: white; }
      .preview-pdf-content table th, .preview-pdf-content table td { padding: 8px; text-align: left; background-color: white; display: table-cell !important; }
      .preview-pdf-content table th { font-weight: 600; }
      .preview-pdf-content table td[style*="background"], .preview-pdf-content table th[style*="background"] { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
      .print-totals { margin-top: 20px; text-align: right; }
      .print-totals-row { display: flex; justify-content: space-between; margin-bottom: 8px; }
      .print-totals-row.print-total { font-weight: 600; font-size: 1.1em; border-top: 2px solid #e5e7eb; padding-top: 8px; margin-top: 8px; }
      .print-notes { margin-top: 20px; padding: 10px; background: #f9fafb !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
      .page-break { page-break-after: always; }
    `;
    const printDoc = `
      <!DOCTYPE html>
      <html>
        <head><meta charset="utf-8"><title>${templateType === 'estimate' ? 'Estimate' : 'Invoice'} - Print</title><style>${printStyles}</style></head>
        <body>
          <div class="preview-pdf-content">${templateContent}</div>
        </body>
      </html>
    `;
    const win = window.open('', '_blank');
    if (!win) {
      alert('Please allow pop-ups to print.');
      return;
    }
    win.document.write(printDoc);
    win.document.close();
    win.focus();
    win.onload = () => {
      win.print();
      win.onafterprint = () => win.close();
    };
  };

  const handleSavePDF = async () => {
    try {
      // Create a mock invoice/estimate document for PDF generation
      const mockDocument = {
        invoice_number: 'PREVIEW-001',
        type: templateType,
        date: new Date().toISOString().split('T')[0],
        due_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        items: JSON.stringify([
          { description: 'Sample Item 1', quantity: 1, unit_price: 100, taxable: true, total: 100 },
          { description: 'Sample Item 2', quantity: 2, unit_price: 50, taxable: true, total: 100 }
        ]),
        subtotal: 200,
        taxable_subtotal: 200,
        non_taxable_subtotal: 0,
        tax_rate: 10,
        tax_amount: 20,
        total: 220,
        notes: 'This is a preview document.',
        hide_totals: false
      };

      const mockClient = {
        name: 'John Smith',
        address: '123 Main Street',
        city: 'San Francisco',
        state: 'CA',
        zip: '94102',
        email: 'john.smith@example.com'
      };

      await downloadPDF(mockDocument, mockClient, templateType);
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF: ' + error.message);
    }
  };

  return (
    <div className="preview-view-container">
      <div className="preview-view-actions">
        <button 
          className="btn-preview-action btn-print"
          onClick={handlePrint}
        >
          🖨️ Print
        </button>
        <button 
          className="btn-preview-action btn-save"
          onClick={handleSavePDF}
        >
          💾 Save as PDF
        </button>
        <div className="preview-info">
          <span className="preview-label">PDF Preview</span>
        </div>
      </div>
      
      <div className="preview-pdf-view" ref={previewRef}>
        <div className="preview-pdf-page" data-paper={pageSettings.paperSize || 'letter'}>
          <div
            className="preview-pdf-content"
            style={marginStyle}
            dangerouslySetInnerHTML={{ __html: templateContent }}
          />
        </div>
      </div>
    </div>
  );
}
